import { render, staticRenderFns } from "./selectCommditySpec.vue?vue&type=template&id=21d96ef0&scoped=true"
import script from "./selectCommditySpec.vue?vue&type=script&lang=js"
export * from "./selectCommditySpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d96ef0",
  null
  
)

export default component.exports